/*

   Common files for the TRAINER environment.

   This still talks to the TRAINER Firebase instance but uses local functions and localhost

*/
import firebase from 'firebase/app'
import 'firebase/functions'

// const serverLoc = 'http://localhost:5001/samanthas-art/us-central1/app/'
const serverBase = 'contrib-trainer.naloxofind.com'
const serverLoc = 'https://contrib-trainer.naloxofind.com/'
const emailDomain = 'naloxofind-trainer.com'

var firebaseConfig = {
    apiKey: "AIzaSyB_IcCGPuKt3hUXNPqdgHmn0_b65uS1l8o",
    authDomain: "naloxofind-trainer.firebaseapp.com",
    databaseURL: "https://naloxofind-trainer.firebaseio.com",
    projectId: "naloxofind-trainer",
    storageBucket: "naloxofind-trainer.appspot.com",
    messagingSenderId: "713972956080"
};



// const mapsAPIkey = "AIzaSyAIDdf82NHO64i78UKsj3-BI0vW3KVHg9k" // For Google Maps NaloxoFind-Test


// const testRecaptchaSiteKey = '6LeE9H8UAAAAAJn1_iYsm4AVbFyZp_Wzt8pb5hlm'

let theFunctions = null
function getFunctions () {
  if (!theFunctions) {
    theFunctions = firebase.functions()
    // theFunctions.useFunctionsEmulator('https://us-central1-naloxofind-test.cloudfunctions.net')
  }
  return theFunctions
}

export default {
  'type' : "trainer",
  'serverBase' : serverBase,
  'serverLoc': serverLoc,
  'firebaseConfig': firebaseConfig,
  'getFunctions': getFunctions,
  'emailDomain': emailDomain,
}
